import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerView } from './container_view';
import { TableView } from './table_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const ProtocolSchedulePreview = ({ productMessages, messages, sortIndex }) => {
    var _a, _b, _c, _d, _e;
    if (!messages) {
        return null;
    }
    const columns = [
        {
            key: 'visit_id',
            label: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.visit_id) !== null && _a !== void 0 ? _a : 'Visit',
            render: (value) => _jsx("span", { style: { color: '#3B82F6' }, children: value }),
        },
        { key: 'tasks', label: (_b = productMessages === null || productMessages === void 0 ? void 0 : productMessages.tasks) !== null && _b !== void 0 ? _b : 'Tasks' },
        { key: 'task_response', label: (_c = productMessages === null || productMessages === void 0 ? void 0 : productMessages.task_response) !== null && _c !== void 0 ? _c : 'Task Response' },
        { key: 'start_date', label: (_d = productMessages === null || productMessages === void 0 ? void 0 : productMessages.start_date) !== null && _d !== void 0 ? _d : 'Start Date' },
        { key: 'end_date', label: (_e = productMessages === null || productMessages === void 0 ? void 0 : productMessages.end_date) !== null && _e !== void 0 ? _e : 'End Date' },
    ];
    const data = Object.keys(messages)
        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
        .map((message) => ({
        visit_id: messages[message],
        tasks: 0,
        task_response: 0,
        start_date: '-',
        end_date: '-',
    }));
    return [
        _jsx(ContainerView, { children: _jsx("div", { style: { padding: '2rem' }, children: _jsx(TableView, { data: data, columns: columns }) }) }, 'protocol-schedule-root'),
    ];
};
//# sourceMappingURL=protocol_schedule.previews.component.js.map